export default __webpack_public_path__ + "static/media/Help-Icon.3f22fd81.svg";